import { NgModule } from '@angular/core'
import { sharedModules } from './constant/shared-modules'

@NgModule({
    imports: [...sharedModules],
    exports: [...sharedModules]
})
export class SharedModule {}
